var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-item"},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.image.url,"fit":"cover"}},[_c('span',{staticClass:"image-placeholder",attrs:{"slot":"placeholder"},slot:"placeholder"},[_vm._v("加载中...")])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }